import ReactiveDialog from "components/common/ReactiveDialog";
import { ImportCalendar } from "./imports";
import useIsMobile from "components/hooks/useIsMobile";
import { useTwoWaySyncEnabled } from "../useTwoWaySyncEnabled";

export default ({
  open,
  importType,
  onClose,
  onSuccess,
  familyRef,
}: {
  open: boolean;
  importType: ImportCalendar;
  onClose: () => void;
  onSuccess: (s: string) => void;
  // onFailure: (s: string) => void;
  familyRef?: string;
}) => {
  const isMobile = useIsMobile();
  const isTwoWaySyncEnabled = useTwoWaySyncEnabled();

  // Determine modal title for Google Calendar
  let modalTitle = importType.getModalTitle();
  if (importType.name === "google") {
    modalTitle =
      !isMobile && isTwoWaySyncEnabled
        ? "Select your Google Calendar permissions"
        : "Google Calendar";
  }

  return (
    <ReactiveDialog
      open={open}
      onClose={onClose}
      title={modalTitle}
      fullWidthSize={importType.getModalWidth() || "md"}
    >
      {importType.getContent(
        onSuccess,
        () => {
          // onFailure("Failed to import calendar");
          onClose();
        },
        familyRef,
      )}
    </ReactiveDialog>
  );
};
